<mat-toolbar class="mat-elevation-z8">
  {{ 'PRICING.PRICING' | transloco }}
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3">
  <form [formGroup]="pricingForm" [ngClass]="{'disabled-form': data.edit}">
    <mat-form-field class="mb-2 w-100">
      <input matInput [placeholder]="'PRICING.DISCOUNTCHECK.DISCOUNTCODE' | transloco" formControlName="discountCode"
        required>
      @if (!pricingForm.controls.discountCode.valid && pricingForm.controls.discountCode.touched) {
        <mat-error>
          {{'PRICING.DISCOUNTCHECK.VALIDATIONS.DISCOUNT_CODE_REQUIRED' | transloco}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="" appearance="outline">
      <mat-label>{{ 'PRICING.DISCOUNTCHECK.PARKING' | transloco }}</mat-label>
      <mat-select formControlName="parkingId">
        <mat-option value="">
          {{ 'PRICING.DISCOUNTCHECK.ALL_PARKINGS' | transloco }}
        </mat-option>
        @for (parking of data.organization.config.parkings; track parking) {
          <mat-option [value]="parking.parkingId">
            {{ parking.parkingName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="radio-grp-container mb-4 ms-1">
      <mat-label>
        {{ 'PRICING.DISCOUNTCHECK.DISCOUNT_TYPE' | transloco }}
      </mat-label>
      <mat-radio-group formControlName="discountType" aria-label="Select an option">
        <mat-radio-button class="me-3" value="discountPercent">{{ 'PRICING.DISCOUNTCHECK.DISCOUNTPERCENT' | transloco
        }}</mat-radio-button>
        <mat-radio-button value="discountAmount">{{ 'PRICING.DISCOUNTCHECK.DISCOUNTAMOUNT' | transloco
        }}</mat-radio-button>
      </mat-radio-group>
    </div>

    @if (isFormInitialized) {
      <div class="checkbox-group mb-4">
        <mat-label>{{ 'PRICING.DISCOUNTCHECK.APPLY_TO' | transloco }}</mat-label>
        <div formArrayName="discountCheckTypes">
          @for (type of discountCheckTypes; track type; let i = $index) {
            <div class="checkbox-item">
              <mat-checkbox [formControl]="discountCheckTypesArray.controls[i]">
                {{ 'PRICING.DISCOUNTCHECK.TYPES.' + type.name | transloco }}
              </mat-checkbox>
            </div>
          }
        </div>
        @if (pricingForm.get('discountCheckTypes')?.errors?.required && pricingForm.get('discountCheckTypes')?.touched) {
          <mat-error
            >
            {{ 'PRICING.DISCOUNTCHECK.VALIDATIONS.SELECT_AT_LEAST_ONE' | transloco }}
          </mat-error>
        }
      </div>
    }

    @if (!isFormInitialized) {
      <div class="loading-checkboxes">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    }

    @if (pricingForm.controls.discountType.value==='discountPercent') {
      <mat-form-field class="mb-2" appearance="outline"
        >
        <mat-label>{{ 'PRICING.DISCOUNTCHECK.DISCOUNTPERCENT' | transloco }}</mat-label>
        <input matInput min="1" type="number" min="0" max="100" formControlName="discountPercent" />
        @if (pricingForm.controls.discountPercent.errors?.discountValidationError && pricingForm.controls.discountPercent.touched) {
          <mat-error class="mb-2"
            >
            {{'PRICING.DISCOUNTCHECK.VALIDATIONS.DISCOUNT_PERCENT_OR_DISCOUNT_AMOUNT_REQUIRED' | transloco}}
          </mat-error>
        }
      </mat-form-field>
    }

    @if (pricingForm.controls.discountType.value==='discountAmount') {
      <mat-form-field class="mb-2" appearance="outline"
        >
        <mat-label>{{ 'PRICING.DISCOUNTCHECK.DISCOUNTAMOUNT' | transloco }}</mat-label>
        <input matInput min="1" type="number" formControlName="discountAmount" />
        @if (pricingForm.controls.discountAmount.errors?.discountValidationError && pricingForm.controls.discountAmount.touched) {
          <mat-error class="mb-2"
            >
            {{'PRICING.DISCOUNTCHECK.VALIDATIONS.DISCOUNT_PERCENT_OR_DISCOUNT_AMOUNT_REQUIRED' | transloco}}
          </mat-error>
        }
      </mat-form-field>
    }


    <mat-form-field class="" appearance="outline">
      <mat-label>{{ 'PRICING.DISCOUNTCHECK.VALIDFROM' | transloco }}</mat-label>
      <input matInput class="date-input" [matDatepicker]="validFrom" formControlName="validFrom"
        (dateChange)="setSwedishTimeZone('validFrom', $event)" />
      <mat-datepicker-toggle matSuffix [for]="validFrom"></mat-datepicker-toggle>
      <mat-datepicker touchUi #validFrom></mat-datepicker>
      <!-- <mat-icon class="date-cancel-icon" matDatepickerToggleIcon
    (click)="clearDate($event, pricingForm.controls['validFrom'])">clear</mat-icon> -->
  </mat-form-field>

  <mat-form-field class="" appearance="outline">
    <mat-label>{{ 'PRICING.DISCOUNTCHECK.VALIDTO' | transloco }}</mat-label>
    <input matInput class="date-input" [matDatepicker]="validTo" formControlName="validTo"
      (dateChange)="setSwedishTimeZone('validTo', $event)" />
    <mat-datepicker-toggle matSuffix [for]="validTo"></mat-datepicker-toggle>
    <mat-datepicker touchUi #validTo></mat-datepicker>
  </mat-form-field>

  @if (usedInQuotas) {
    <p class="quota-lock-hint">
      {{ 'PRICING.DISCOUNTCHECK.VALIDITY_LOCKED_BY_QUOTAS' | transloco: { parkings: quotaParkingNames.join(', ') } }}
    </p>
  }
</form>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <!-- pricingForm.dirty -->
  <button mat-raised-button color="primary" [disabled]="pricingForm.invalid || isLoading" (click)="submitForm()">
    @if (!data.edit) {
      <span>
        {{ 'PRICING.FORM.CREATE' | transloco }}
      </span>
    }
    @if (data.edit) {
      <span>
        {{'PRICING.FORM.EDIT' | transloco }}
      </span>
    }
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>